import type { ColorSpec } from './types';
import { purple } from './purple';

/**
 * Aurora — a gradient "color". Only the filled tone is a true gradient
 * (#4D4ACC → #792D86). Outline + soft fall back to the purple palette so
 * the orthogonal `color="aurora" tone="outline|soft"` API still produces
 * a coherent result, just rendered as plain purple.
 *
 * Implementation: spread the purple spec, then override the filled-mode
 * slots (button bg, badge, input bg) with the gradient.
 */
export const aurora: ColorSpec = {
  ...purple,
  filled: {
    border: 'border-transparent',
    bg: 'bg-linear-to-r from-[#4D4ACC] to-[#792D86] text-white shadow-xs',
    bgActive: 'bg-linear-to-r from-[#2e2c8a] to-[#45174f] text-white',
    hover:
      'hover:from-[#3a38a8] hover:to-[#581d63] hover:text-white active:from-[#2e2c8a] active:to-[#45174f] active:text-white',
    hoverDark:
      'dark:hover:from-[#3a38a8] dark:hover:to-[#581d63] dark:hover:text-white dark:active:from-[#2e2c8a] dark:active:to-[#45174f] dark:active:text-white',
  },
  textFilled: {
    text: 'text-slate-400 dark:text-slate-400',
    activeBg: 'bg-linear-to-r from-[#4D4ACC] to-[#792D86] text-white',
    hover:
      'hover:bg-linear-to-r hover:from-[#4D4ACC] hover:to-[#792D86] hover:text-white active:from-[#3a38a8] active:to-[#581d63]',
    hoverDark: 'dark:hover:text-white',
  },
  tooltip: 'bg-linear-to-r from-[#4D4ACC] to-[#792D86] text-white',
  badge: {
    ...purple.badge,
    filled: 'bg-linear-to-r from-[#4D4ACC] to-[#792D86] text-white',
  },
  input: {
    ...purple.input,
    filled: {
      border: 'border-transparent',
      bg: 'bg-linear-to-r from-[#4D4ACC] to-[#792D86]',
      focusBg: 'focus-within:from-[#3a38a8] focus-within:to-[#581d63]',
      focusOutline:
        'focus-within:outline-solid focus-within:outline-2 focus-within:outline-offset-1 focus-within:outline-purple-500',
      hoverActive:
        'hover:from-[#3a38a8] hover:to-[#581d63] hover:text-white active:from-[#2e2c8a] active:to-[#45174f] active:text-white',
      readOnlyBg: 'bg-linear-to-r from-[#3a38a8] to-[#581d63]',
      text: 'text-white',
    },
  },
};
